import { render, staticRenderFns } from "./CustomerDisplay.vue?vue&type=template&id=68e896c1&"
import script from "./CustomerDisplay.vue?vue&type=script&lang=js&"
export * from "./CustomerDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports